import { IconComponent, IconName } from '@/components/icons/DynamicIcon';
import { MATERIAL_SYMBOL_ICONS } from 'shared/custom/constants/commonConstants';

export const iconLoaders = {
	[MATERIAL_SYMBOL_ICONS.person]: () =>
		import('./svg/Person').then((mod) => ({ default: mod.PersonIcon })),
	[MATERIAL_SYMBOL_ICONS.wishlist]: () =>
		import('./svg/Wishlist').then((mod) => ({ default: mod.WishlistIcon })),
	[MATERIAL_SYMBOL_ICONS.recentOrders]: () =>
		import('./svg/RecentOrders').then((mod) => ({
			default: mod.RecentOrdersIcon,
		})),
	[MATERIAL_SYMBOL_ICONS.department]: () =>
		import('./svg/Department').then((mod) => ({ default: mod.DepartmentIcon })),
	[MATERIAL_SYMBOL_ICONS.chevronLeft]: () =>
		import('./svg/ChevronLeft').then((mod) => ({
			default: mod.ChevronLeftIcon,
		})),
	[MATERIAL_SYMBOL_ICONS.chevronRight]: () =>
		import('./svg/ChevronRight').then((mod) => ({
			default: mod.ChevronRightIcon,
		})),
	[MATERIAL_SYMBOL_ICONS.shoppingCart]: () =>
		import('./svg/ShoppingCart').then((mod) => ({
			default: mod.ShoppingCartIcon,
		})),
	[MATERIAL_SYMBOL_ICONS.stacks]: () =>
		import('./svg/StacksIcon').then((mod) => ({ default: mod.StacksIcon })),
	[MATERIAL_SYMBOL_ICONS.bolt]: () =>
		import('./svg/Bolt').then((mod) => ({ default: mod.BoltIcon })),
	[MATERIAL_SYMBOL_ICONS.assignmentInd]: () =>
		import('./svg/AssignmentInd').then((mod) => ({
			default: mod.AssignmentIndIcon,
		})),
	[MATERIAL_SYMBOL_ICONS.block]: () =>
		import('./svg/Block').then((mod) => ({ default: mod.BlockIcon })),
	[MATERIAL_SYMBOL_ICONS.wallet]: () =>
		import('./svg/Wallet').then((mod) => ({ default: mod.WalletIcon })),
	[MATERIAL_SYMBOL_ICONS.locationOn]: () =>
		import('./svg/LocationOn').then((mod) => ({ default: mod.LocationOnIcon })),
	[MATERIAL_SYMBOL_ICONS.search]: () =>
		import('./svg/Search').then((mod) => ({ default: mod.SearchIcon })),
	[MATERIAL_SYMBOL_ICONS.filterList]: () =>
		import('./svg/FilterList').then((mod) => ({ default: mod.FilterListIcon })),
	[MATERIAL_SYMBOL_ICONS.cancel]: () =>
		import('./svg/Cancel').then((mod) => ({ default: mod.CancelIcon })),
	[MATERIAL_SYMBOL_ICONS.helpCenter]: () =>
		import('./svg/HelpCenter').then((mod) => ({ default: mod.HelpCenterIcon })),
	[MATERIAL_SYMBOL_ICONS.house]: () =>
		import('./svg/House').then((mod) => ({ default: mod.HouseIcon })),
	[MATERIAL_SYMBOL_ICONS.creditCard]: () =>
		import('./svg/CreditCard').then((mod) => ({ default: mod.CreditCardIcon })),
	[MATERIAL_SYMBOL_ICONS.favorite]: () =>
		import('./svg/Favorite').then((mod) => ({ default: mod.FavoriteIcon })),
	[MATERIAL_SYMBOL_ICONS.add]: () => import('./svg/Add').then((mod) => ({ default: mod.AddIcon })),
	[MATERIAL_SYMBOL_ICONS.package]: () =>
		import('./svg/Package').then((mod) => ({ default: mod.PackageIcon })),
	[MATERIAL_SYMBOL_ICONS.shoppingCartCheckout]: () =>
		import('./svg/ShoppingCartCheckout').then((mod) => ({
			default: mod.ShoppingCartCheckoutIcon,
		})),
	[MATERIAL_SYMBOL_ICONS.home]: () =>
		import('./svg/Home').then((mod) => ({ default: mod.HomeIcon })),
	[MATERIAL_SYMBOL_ICONS.checkCircle]: () =>
		import('./svg/CheckCircle').then((mod) => ({
			default: mod.CheckCircleIcon,
		})),
	[MATERIAL_SYMBOL_ICONS.info]: () =>
		import('./svg/Info').then((mod) => ({ default: mod.InfoIcon })),
	[MATERIAL_SYMBOL_ICONS.mail]: () =>
		import('./svg/Mail').then((mod) => ({ default: mod.MailIcon })),
	[MATERIAL_SYMBOL_ICONS.accountCircle]: () =>
		import('./svg/AccountCircle').then((mod) => ({
			default: mod.AccountCircleIcon,
		})),
	[MATERIAL_SYMBOL_ICONS.call]: () =>
		import('./svg/Call').then((mod) => ({ default: mod.CallIcon })),
	[MATERIAL_SYMBOL_ICONS.addCall]: () =>
		import('./svg/AddCall').then((mod) => ({ default: mod.AddCallIcon })),
	[MATERIAL_SYMBOL_ICONS.addLocationAlt]: () =>
		import('./svg/AddLocationAlt').then((mod) => ({
			default: mod.AddLocationAltIcon,
		})),
	[MATERIAL_SYMBOL_ICONS.myLocation]: () =>
		import('./svg/MyLocation').then((mod) => ({ default: mod.MyLocationIcon })),
	[MATERIAL_SYMBOL_ICONS.check]: () =>
		import('./svg/Check').then((mod) => ({ default: mod.CheckIcon })),
	[MATERIAL_SYMBOL_ICONS.calendar]: () =>
		import('./svg/Calendar').then((mod) => ({ default: mod.CalendarIcon })),
	[MATERIAL_SYMBOL_ICONS.store]: () =>
		import('./svg/Store').then((mod) => ({ default: mod.StoreIcon })),
	[MATERIAL_SYMBOL_ICONS.delete]: () =>
		import('./svg/Delete').then((mod) => ({ default: mod.DeleteIcon })),
	[MATERIAL_SYMBOL_ICONS.bopis]: () =>
		import('./svg/Bopis').then((mod) => ({ default: mod.BopisIcon })),
	[MATERIAL_SYMBOL_ICONS.exclamation]: () =>
		import('./svg/Exclamation').then((mod) => ({
			default: mod.ExclamationIcon,
		})),
	[MATERIAL_SYMBOL_ICONS.browse]: () =>
		import('./svg/Browse').then((mod) => ({ default: mod.BrowseIcon })),
	[MATERIAL_SYMBOL_ICONS.storefront]: () =>
		import('./svg/Storefront').then((mod) => ({ default: mod.StorefrontIcon })),
	[MATERIAL_SYMBOL_ICONS.close]: () =>
		import('./svg/Close').then((mod) => ({ default: mod.CloseIcon })),
	[MATERIAL_SYMBOL_ICONS.scene]: () =>
		import('./svg/Scene').then((mod) => ({ default: mod.SceneIcon })),
	[MATERIAL_SYMBOL_ICONS.bathtub]: () =>
		import('./svg/Bathtub').then((mod) => ({ default: mod.BathtubIcon })),
	[MATERIAL_SYMBOL_ICONS.skillet]: () =>
		import('./svg/Skillet').then((mod) => ({ default: mod.SkilletIcon })),
	[MATERIAL_SYMBOL_ICONS.wallArt]: () =>
		import('./svg/WallArt').then((mod) => ({ default: mod.WallArtIcon })),
	[MATERIAL_SYMBOL_ICONS.electricalServices]: () =>
		import('./svg/ElectricalServices').then((mod) => ({
			default: mod.ElectricalServicesIcon,
		})),
	[MATERIAL_SYMBOL_ICONS.googleHomeDevices]: () =>
		import('./svg/GoogleHomeDevices').then((mod) => ({
			default: mod.GoogleHomeDevicesIcon,
		})),
	[MATERIAL_SYMBOL_ICONS.key]: () => import('./svg/Key').then((mod) => ({ default: mod.KeyIcon })),
	[MATERIAL_SYMBOL_ICONS.skull]: () =>
		import('./svg/Skull').then((mod) => ({ default: mod.SkullIcon })),
	[MATERIAL_SYMBOL_ICONS.toolsPowerDrill]: () =>
		import('./svg/ToolsPowerDrill').then((mod) => ({
			default: mod.ToolsPowerDrillIcon,
		})),
	[MATERIAL_SYMBOL_ICONS.lightGroup]: () =>
		import('./svg/LightGroup').then((mod) => ({ default: mod.LightGroupIcon })),
	[MATERIAL_SYMBOL_ICONS.deceased]: () =>
		import('./svg/Deceased').then((mod) => ({ default: mod.DeceasedIcon })),
	[MATERIAL_SYMBOL_ICONS.cleanHands]: () =>
		import('./svg/CleanHands').then((mod) => ({ default: mod.CleanHandsIcon })),
	[MATERIAL_SYMBOL_ICONS.kitchen]: () =>
		import('./svg/Kitchen').then((mod) => ({ default: mod.KitchenIcon })),
	[MATERIAL_SYMBOL_ICONS.gardenCart]: () =>
		import('./svg/GardenCart').then((mod) => ({ default: mod.GardenCartIcon })),
	[MATERIAL_SYMBOL_ICONS.chair]: () =>
		import('./svg/Chair').then((mod) => ({ default: mod.ChairIcon })),
	[MATERIAL_SYMBOL_ICONS.park]: () =>
		import('./svg/Park').then((mod) => ({ default: mod.ParkIcon })),
	[MATERIAL_SYMBOL_ICONS.shelves]: () =>
		import('./svg/Shelves').then((mod) => ({ default: mod.ShelvesIcon })),
	[MATERIAL_SYMBOL_ICONS.imagesearchRoller]: () =>
		import('./svg/ImagesearchRoller').then((mod) => ({
			default: mod.ImagesearchRollerIcon,
		})),
	[MATERIAL_SYMBOL_ICONS.borderAll]: () =>
		import('./svg/BorderAll').then((mod) => ({ default: mod.BorderAllIcon })),
	[MATERIAL_SYMBOL_ICONS.valve]: () =>
		import('./svg/Valve').then((mod) => ({ default: mod.ValveIcon })),
	[MATERIAL_SYMBOL_ICONS.doorSliding]: () =>
		import('./svg/DoorSliding').then((mod) => ({
			default: mod.DoorSlidingIcon,
		})),
	[MATERIAL_SYMBOL_ICONS.speedCamera]: () =>
		import('./svg/SpeedCamera').then((mod) => ({
			default: mod.SpeedCameraIcon,
		})),
	[MATERIAL_SYMBOL_ICONS.climateMiniSplit]: () =>
		import('./svg/ClimateMiniSplit').then((mod) => ({
			default: mod.ClimateMiniSplitIcon,
		})),
	[MATERIAL_SYMBOL_ICONS.login]: () =>
		import('./svg/Login').then((mod) => ({ default: mod.LoginIcon })),
	[MATERIAL_SYMBOL_ICONS.subdirectoryArrowRight]: () =>
		import('./svg/SubdirectoryArrowRight').then((mod) => ({
			default: mod.SubdirectoryArrowRightIcon,
		})),
	[MATERIAL_SYMBOL_ICONS.keyboardArrowRight]: () =>
		import('./svg/KeyboardArrowRight').then((mod) => ({
			default: mod.KeyboardArrowRightIcon,
		})),
	[MATERIAL_SYMBOL_ICONS.keyboardArrowLeft]: () =>
		import('./svg/KeyboardArrowLeft').then((mod) => ({
			default: mod.KeyboardArrowLeftIcon,
		})),
	[MATERIAL_SYMBOL_ICONS.package2]: () =>
		import('./svg/Package2').then((mod) => ({ default: mod.Package2Icon })),
	[MATERIAL_SYMBOL_ICONS.supervisedUserCircle]: () =>
		import('./svg/SupervisedUserCircle').then((mod) => ({
			default: mod.SupervisedUserCircleIcon,
		})),
	[MATERIAL_SYMBOL_ICONS.engineering]: () =>
		import('./svg/Engineering').then((mod) => ({
			default: mod.EngineeringIcon,
		})),
	[MATERIAL_SYMBOL_ICONS.receiptLong]: () =>
		import('./svg/ReceiptLong').then((mod) => ({
			default: mod.ReceiptLongIcon,
		})),
	[MATERIAL_SYMBOL_ICONS.help]: () =>
		import('./svg/Help').then((mod) => ({
			default: mod.HelpIcon,
		})),
	[MATERIAL_SYMBOL_ICONS.doorOpen]: () =>
		import('./svg/DoorOpen').then((mod) => ({
			default: mod.DoorOpenIcon,
		})),
	[MATERIAL_SYMBOL_ICONS.verified]: () =>
		import('./svg/Verified').then((mod) => ({
			default: mod.VerifiedIcon,
		})),
	[MATERIAL_SYMBOL_ICONS.backspace]: () =>
		import('./svg/Backspace').then((mod) => ({
			default: mod.BackspaceIcon,
		})),
	[MATERIAL_SYMBOL_ICONS.box]: () =>
		import('./svg/Box').then((mod) => ({
			default: mod.BoxIcon,
		})),
	[MATERIAL_SYMBOL_ICONS.brightnessAlert]: () =>
		import('./svg/BrightnessAlert').then((mod) => ({
			default: mod.BrightnessAlertIcon,
		})),
	[MATERIAL_SYMBOL_ICONS.colors]: () =>
		import('./svg/Colors').then((mod) => ({
			default: mod.ColorsIcon,
		})),
	[MATERIAL_SYMBOL_ICONS.contentCopy]: () =>
		import('./svg/ContentCopy').then((mod) => ({
			default: mod.ContentCopyIcon,
		})),
	[MATERIAL_SYMBOL_ICONS.editSquare]: () =>
		import('./svg/EditSquare').then((mod) => ({
			default: mod.EditSquareIcon,
		})),
	[MATERIAL_SYMBOL_ICONS.frameInspect]: () =>
		import('./svg/FrameInspect').then((mod) => ({
			default: mod.FrameInspectIcon,
		})),
	[MATERIAL_SYMBOL_ICONS.trolley]: () =>
		import('./svg/Trolley').then((mod) => ({
			default: mod.TrolleyIcon,
		})),
	[MATERIAL_SYMBOL_ICONS.devices]: () =>
		import('./svg/Devices').then((mod) => ({
			default: mod.DevicesIcon,
		})),
	[MATERIAL_SYMBOL_ICONS.remove]: () =>
		import('./svg/Remove').then((mod) => ({
			default: mod.RemoveIcon,
		})),
	[MATERIAL_SYMBOL_ICONS.tune]: () =>
		import('./svg/Tune').then((mod) => ({
			default: mod.TuneIcon,
		})),
	[MATERIAL_SYMBOL_ICONS.dashboardCustomize]: () =>
		import('./svg/DashboardCustomize').then((mod) => ({
			default: mod.DashboardCustomizeIcon,
		})),

	[MATERIAL_SYMBOL_ICONS.checkbox]: () =>
		import('./svg/Checkbox').then((mod) => ({
			default: mod.CheckboxIcon,
		})),
	[MATERIAL_SYMBOL_ICONS.checkboxBlank]: () =>
		import('./svg/CheckboxOutlinedBlank').then((mod) => ({
			default: mod.CheckboxOutlinedBlankIcon,
		})),
	[MATERIAL_SYMBOL_ICONS.edit]: () =>
		import('./svg/Edit').then((mod) => ({
			default: mod.EditIcon,
		})),
	[MATERIAL_SYMBOL_ICONS.manageSearch]: () =>
		import('./svg/ManageSearch').then((mod) => ({
			default: mod.ManageSearchIcon,
		})),
	[MATERIAL_SYMBOL_ICONS.dangerous]: () =>
		import('./svg/Dangerous').then((mod) => ({
			default: mod.DangerousIcon,
		})),
	[MATERIAL_SYMBOL_ICONS.bookmarkHeart]: () =>
		import('./svg/BookmarkHeart').then((mod) => ({
			default: mod.BookmarkHeartIcon,
		})),
	[MATERIAL_SYMBOL_ICONS.history]: () =>
		import('./svg/History').then((mod) => ({
			default: mod.HistoryIcon,
		})),
	[MATERIAL_SYMBOL_ICONS.map]: () =>
		import('./svg/Map').then((mod) => ({
			default: mod.MapIcon,
		})),
	[MATERIAL_SYMBOL_ICONS.directions]: () =>
		import('./svg/Directions').then((mod) => ({
			default: mod.DirectionsIcon,
		})),
	[MATERIAL_SYMBOL_ICONS.pinDrop]: () =>
		import('./svg/PinDrop').then((mod) => ({
			default: mod.PinDropIcon,
		})),
	[MATERIAL_SYMBOL_ICONS.swapHoriz]: () =>
		import('./svg/SwapHoriz').then((mod) => ({
			default: mod.SwapHorizIcon,
		})),
	[MATERIAL_SYMBOL_ICONS.share]: () =>
		import('./svg/Share').then((mod) => ({ default: mod.ShareIcon })),
	[MATERIAL_SYMBOL_ICONS.facebook]: () =>
		import('./svg/Facebook').then((mod) => ({ default: mod.FacebookIcon })),
	[MATERIAL_SYMBOL_ICONS.whatsapp]: () =>
		import('./svg/Whatsapp').then((mod) => ({ default: mod.WhatsappIcon })),
	[MATERIAL_SYMBOL_ICONS.pinterest]: () =>
		import('./svg/Pinterest').then((mod) => ({ default: mod.PinterestIcon })),
	[MATERIAL_SYMBOL_ICONS.viewInAr]: () =>
		import('./svg/ViewInAr').then((mod) => ({ default: mod.ViewInArIcon })),
	[MATERIAL_SYMBOL_ICONS.touchApp]: () =>
		import('./svg/TouchApp').then((mod) => ({ default: mod.TouchAppIcon })),
	[MATERIAL_SYMBOL_ICONS.swipe]: () =>
		import('./svg/Swipe').then((mod) => ({ default: mod.SwipeIcon })),
	[MATERIAL_SYMBOL_ICONS.photoLibrary]: () =>
		import('./svg/PhotoLibrary').then((mod) => ({ default: mod.PhotoLibraryIcon })),
	[MATERIAL_SYMBOL_ICONS.rotate360]: () =>
		import('./svg/Rotate360').then((mod) => ({ default: mod.Rotate360Icon })),
	[MATERIAL_SYMBOL_ICONS.smartDisplay]: () =>
		import('./svg/SmartDisplay').then((mod) => ({ default: mod.SmartDisplayIcon })),
	[MATERIAL_SYMBOL_ICONS.galleryThumbnail]: () =>
		import('./svg/GalleryThumbnail').then((mod) => ({ default: mod.GalleryThumbnailIcon })),
	[MATERIAL_SYMBOL_ICONS.featuredSeasonalAndGifts]: () =>
		import('./svg/FeaturedSeasonalAndGifts').then((mod) => ({
			default: mod.FeaturedSeasonalAndGiftsIcon,
		})),
	[MATERIAL_SYMBOL_ICONS.arrowForward]: () =>
		import('./svg/ArrowForward').then((mod) => ({
			default: mod.ArrowForwardIcon,
		})),
	[MATERIAL_SYMBOL_ICONS.arrowDownward]: () =>
		import('./svg/ArrowDownward').then((mod) => ({
			default: mod.ArrowDownwardIcon,
		})),
	[MATERIAL_SYMBOL_ICONS.awardStar]: () =>
		import('./svg/AwardStar').then((mod) => ({
			default: mod.AwardStarIcon,
		})),
	[MATERIAL_SYMBOL_ICONS.localActivity]: () =>
		import('./svg/LocalActivity').then((mod) => ({ default: mod.LocalActivityIcon })),
	[MATERIAL_SYMBOL_ICONS.releaseAlert]: () =>
		import('./svg/ReleaseAlert').then((mod) => ({ default: mod.ReleaseAlertIcon })),
	[MATERIAL_SYMBOL_ICONS.localShipping]: () =>
		import('./svg/LocalShipping').then((mod) => ({
			default: mod.LocalShippingIcon,
		})),
	[MATERIAL_SYMBOL_ICONS.storePickup]: () =>
		import('./svg/StorePickup').then((mod) => ({
			default: mod.StorePickupIcon,
		})),
	[MATERIAL_SYMBOL_ICONS.emergencyHome]: () =>
		import('./svg/EmergencyHome').then((mod) => ({
			default: mod.EmergencyHomeIcon,
		})),
	[MATERIAL_SYMBOL_ICONS.keyboardArrowDown]: () =>
		import('./svg/KeyboardArrowDown').then((mod) => ({
			default: mod.KeyboardArrowDownIcon,
		})),
	[MATERIAL_SYMBOL_ICONS.keyboardArrowUp]: () =>
		import('./svg/KeyboardArrowUp').then((mod) => ({
			default: mod.KeyboardArrowUpIcon,
		})),
	[MATERIAL_SYMBOL_ICONS.deck]: () =>
		import('./svg/Deck').then((mod) => ({
			default: mod.DeckIcon,
		})),
	// add more icons...
} satisfies Record<IconName, () => Promise<{ default: IconComponent }>>;
